export default {
  title: {
    id: 'buyback_refurbisher_on_hold_modal_on_hold_reasons_title',
    defaultMessage: 'Why can’t the order be processed?',
  },
  info: {
    id: 'buyback_refurbisher_on_hold_modal_on_hold_reasons_info',
    defaultMessage: 'Select all that apply',
  },
  requiredErrorMessage: {
    id: 'buyback_refurbisher_on_hold_modal_on_hold_reasons_error_message',
    defaultMessage: 'Please select at least one reason',
  },
}
